import { useEffect, useMemo, useState } from 'react';
import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import { useDebounce } from '../hooks';
import { useField } from '@unform/core';
import { AreasService } from '../services/api/AreasService';

type TAutoCompleteOption = {
  codarea: number;
  label: number;
}

interface IAutoCompleteSubgruposProps {
  isExternalLoading?: boolean;
  codfaz?: number;
}

export const AutoCompleteArea: React.FC<IAutoCompleteSubgruposProps> = ({ isExternalLoading = false, codfaz = 0 }) => {

  const { fieldName, registerField, defaultValue, error, clearError } = useField('codarea');

  const { debounce } = useDebounce();

  const [selectedId, setSelectedId] = useState<number | undefined>(defaultValue);

  const [opcoes, setOpcoes] = useState<TAutoCompleteOption[]>([]);

  const [isLoading, setIsLoading] = useState(false);
  
  const [busca, setBusca] = useState('');

  useEffect(() => {
    registerField({
      name: fieldName,
      getValue: () => selectedId,
      setValue: (_, newSelectedId) => setSelectedId(newSelectedId),
    });
  }, [registerField, fieldName, selectedId]);

  useEffect(() => {
    setSelectedId(undefined);
    setBusca('');
  }, [codfaz]);

  useEffect(() => {
    setIsLoading(true);
    debounce(() => {
      AreasService.getAlllist(codfaz, selectedId)
        .then((result) => {
          setIsLoading(false);
          if (result instanceof Error) {
          } else {
            setOpcoes(result.data.map(areas => ({ codarea: areas.codarea, label: areas.descricao })));
          }
        });
    });
  },[codfaz, busca, selectedId]);
 
  const autoCompleteSelectedOption = useMemo(() => {
    if (!selectedId) return null;

    const selectedOption = opcoes.find(opcao => opcao.codarea === selectedId);
    if (!selectedOption) return null;

    return selectedOption;
  }, [selectedId, opcoes]);
  
  return (
    <Autocomplete
      openText='Abrir'
      closeText='Fechar'
      noOptionsText='Sem opções'
      loadingText='Carregando...' 
      fullWidth
      disablePortal
      options={opcoes}
      loading={isLoading}
      disabled={isExternalLoading}
      value={autoCompleteSelectedOption}
      onInputChange={(_, newValue) => setBusca(newValue)}
      onChange={(_, newValue) => { setSelectedId(newValue?.codarea); setBusca(''); clearError(); }}
      popupIcon={(isExternalLoading || isLoading) ? <CircularProgress size={28} /> : undefined}
      renderInput={(params) => (
        <TextField
          {...params}
          size='small'
          label="Áreas"
          error={!!error}
          helperText={error}
        />
      )}
    />
  );
};